let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined,
  name: {
    vi: "",
    en: "",
  },
  support_type: undefined,
  index: undefined,
  icon: "",
  tooltip: null,
};

model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "index,name.vi",
  defaultSort: ["index", "ascending"],
  fields: "id,name,support_type,tooltip,index,icon",
  filters: "",
  dataSearch: {
    value: {
      "name.vi": "",
      "name.en": "",
      support_type: "",
    },
    operator: {
      "name.vi": ":regex_i:",
      "name.en": ":regex_i:",
      support_type: "=",
    },
  },
};

model.supportTypeOptions = [
  {
    value: "tong_hop",
    labelKey: "t_support_type_tong_hop",
  },
  {
    value: "chi_tiet",
    labelKey: "t_support_type_chi_tiet",
  },
  {
    value: "ca_hai",
    labelKey: "t_support_type_ca_hai",
  },
];

export default model;
